import HistoryScreen from "./HistoryScreen";

export default HistoryScreen
